// extracted by mini-css-extract-plugin
module.exports = {"SliderItemSticker":"styles_SliderItemSticker__Tfsg3","cta":"styles_cta__OBz9b","isActive":"styles_isActive__gcpc2"};